export const getBlzStatusLabel = (isBlz) => {
  const validBlzValues = ['1', '2', '3']
  const isPilot = validBlzValues.includes(isBlz)
  return isPilot ? 'Sim' : 'Não'
}
